import { CopyOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";
import { useUser } from "hooks/useUser";
import { FC } from "react";
import { toast } from "react-toastify";

// import ResponseConnectionPropertyData = App.Data.ResponseConnectionPropertyData;

interface StepFormProps {
    disabled?: boolean;
}

export const IncomingPostbackStepForm: FC<StepFormProps> = ({ disabled }) => {
    // const stepSetting = DrawerId.MethodStepSetting;
    const userUtils = useUser();

    // https://api.paldock.com/api/{tenant}/postbacks/handle?conversion_id={conversion_id}&external_id={external_id}&advertiser_id={advertiser_id}&postback_id={postback_id}&type={type}&commission_id={commission_id}

    const apiBaseUrl = `${import.meta.env.VITE_API_URL}/${userUtils.getActiveTenant()?.slug_name}/postbacks/handle`;
    // const queryString = queryParams
    //     .map(
    //         (param: ResponseConnectionPropertyData) =>
    //             `${param.accessor || param.value || "externalID"}=${param.system_name || "{id}"}`
    //     )
    //     .join("&");

    // const dynamicUrl = `${apiBaseUrl}${queryString ? `&${queryString}` : ""}`;
    const dynamicUrl = `${apiBaseUrl}`;

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(dynamicUrl);
        toast.info("Token byl zkopírován do schránky.");
    };

    return (
        <Row gutter={16} align="middle" className="flex flex-wrap w-full">
            <Col xs={22}>
                <Input
                    placeholder={`${import.meta.env.VITE_API_URL}/${userUtils.getActiveTenant()?.slug_name}/postbacks/handle?externalID={id}`}
                    value={dynamicUrl}
                    disabled
                />
            </Col>

            <Col>
                <Button icon={<CopyOutlined />} disabled={disabled} onClick={handleCopyToClipboard} />
            </Col>
            {/* <Col>
                <DrawerLink
                    drawerId={stepSetting}
                    search={{ [${stepSetting}-id]: name?.toString() }}
                    action="show"
                    disabled={disabled}
                >
                    <Button icon={<SettingOutlined />} disabled={disabled} />
                </DrawerLink>
            </Col> */}
        </Row>
    );
};
